import React, { useState, useEffect } from 'react';
import { Search, ChevronDown, Download, X } from 'lucide-react';
import * as XLSX from 'xlsx';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1';

export default function DocenteHistorialPreadmision() {
    const [filters, setFilters] = useState({
        tipo_preadmision: 'curso', // 'curso' o 'prueba'
        id_asignatura: '',
        id_paralelo: '',
        gestion: new Date().getFullYear()
    });

    const [showDownloadModal, setShowDownloadModal] = useState(false);

    const [asignaturas, setAsignaturas] = useState([]);
    const [paralelos, setParalelos] = useState([]);
    const [estudiantes, setEstudiantes] = useState([]);
    const [notas, setNotas] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [inscripcionCerrada, setInscripcionCerrada] = useState(false);
    const [mensajeCierre, setMensajeCierre] = useState('');

    // Cargar notas desde localStorage al cambiar filtros
    useEffect(() => {
        if (filters.id_asignatura && filters.id_paralelo) {
            const cacheKey = `notas_preadm_${filters.id_asignatura}_${filters.id_paralelo}_${filters.tipo_preadmision}`;
            const cached = localStorage.getItem(cacheKey);
            if (cached) {
                try {
                    setNotas(JSON.parse(cached));
                } catch (e) {
                    console.error('Error parsing cached notas:', e);
                }
            }
        }
    }, [filters.id_asignatura, filters.id_paralelo, filters.tipo_preadmision]);

    // Persistir notas a localStorage cada vez que cambian
    useEffect(() => {
        if (filters.id_asignatura && filters.id_paralelo && Object.keys(notas).length > 0) {
            const cacheKey = `notas_preadm_${filters.id_asignatura}_${filters.id_paralelo}_${filters.tipo_preadmision}`;
            localStorage.setItem(cacheKey, JSON.stringify(notas));
        }
    }, [notas, filters.id_asignatura, filters.id_paralelo, filters.tipo_preadmision]);



    // Cargar asignaturas del docente (y recargar si cambia tipo o gestion)
    useEffect(() => {
        loadAsignaturas();
        verificarPeriodoCargadoNotas();
    }, [filters.tipo_preadmision, filters.gestion]);

    const verificarPeriodoCargadoNotas = async () => {
        try {
            const paramName = 'Cargado de notas Admisión (docente)';

            const response = await fetch(`${API_URL}/direccion/parametrizaciones/verificar/${encodeURIComponent(paramName)}`);
            const data = await response.json();

            if (!data.habilitado) {
                setInscripcionCerrada(true);
                setMensajeCierre(data.mensaje || 'El periodo de cargado de notas de admisión se encuentra cerrado.');
            } else {
                setInscripcionCerrada(false);
            }
        } catch (error) {
            console.error('Error verificando periodo:', error);
        }
    };

    // Cargar paralelos cuando cambia asignatura
    useEffect(() => {
        if (filters.id_asignatura) {
            loadParalelos(filters.id_asignatura);
        } else {
            setParalelos([]);
        }
    }, [filters.id_asignatura]);

    // Cargar estudiantes cuando cambia asignatura/paralelo/tipo/gestion
    useEffect(() => {
        if (filters.id_asignatura && filters.id_paralelo) {
            loadEstudiantes();
        } else {
            setEstudiantes([]);
            setNotas({});
        }
    }, [filters.id_asignatura, filters.id_paralelo, filters.tipo_preadmision, filters.gestion]);

    const loadAsignaturas = async () => {
        try {
            const token = localStorage.getItem('token');
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const id_usuario = user.id_usuario || '';
            const tipoAPI = filters.tipo_preadmision === 'prueba' ? 'admision' : 'preadmision';

            const query = new URLSearchParams({
                tipo: tipoAPI,
                id_usuario: id_usuario,
                gestion: filters.gestion
            });

            const response = await fetch(`${API_URL}/docente/asignaturas?${query}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await response.json();
            setAsignaturas(data.asignaturas || []);
            // Limpiar seleccion anterior si no existe en nueva lista
            // if (!data.asignaturas.find(a => a.id_asignatura === filters.id_asignatura)) {
            //     setFilters(prev => ({ ...prev, id_asignatura: '' }));
            // }
        } catch (error) {
            console.error('Error loading asignaturas:', error);
            // Fallback
            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${API_URL}/docente/asignaturas`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                const data = await response.json();
                setAsignaturas(data.asignaturas || []);
            } catch (e) {
                console.error('Error loading fallback asignaturas:', e);
            }
        }
    };

    const loadParalelos = async (id_asignatura) => {
        try {
            const token = localStorage.getItem('token');
            const tipoAPI = filters.tipo_preadmision === 'prueba' ? 'admision' : 'preadmision';
            const query = new URLSearchParams({
                tipo: tipoAPI,
                gestion: filters.gestion
            });
            const response = await fetch(`${API_URL}/docente/paralelos/${id_asignatura}?${query}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await response.json();
            setParalelos(data.paralelos || []);
        } catch (error) {
            console.error('Error loading paralelos:', error);
        }
    };

    const loadEstudiantes = async () => {
        try {
            setLoading(true);
            const tipoAPI = filters.tipo_preadmision === 'prueba' ? 'admision' : 'preadmision';
            const query = new URLSearchParams({
                id_asignatura: filters.id_asignatura,
                tipo: tipoAPI,
                gestion: filters.gestion,
                ...(filters.id_paralelo && { id_paralelo: filters.id_paralelo })
            });

            const token = localStorage.getItem('token');
            const response = await fetch(`${API_URL}/docente/estudiantes?${query}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await response.json();
            setEstudiantes(data.estudiantes || []);

            // Cargar notas existentes
            await loadNotas();
        } catch (error) {
            console.error('Error loading estudiantes:', error);
        } finally {
            setLoading(false);
        }
    };

    const loadNotas = async () => {
        try {
            const query = new URLSearchParams({
                id_asignatura: filters.id_asignatura,
                tipo: filters.tipo_preadmision,
                gestion: filters.gestion,
                ...(filters.id_paralelo && { id_paralelo: filters.id_paralelo })
            });

            const token = localStorage.getItem('token');
            const response = await fetch(`${API_URL}/docente/notas-preadmision?${query}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await response.json();

            // Convertir array a objeto {id_estudiante: {proceso, evaluacion, nota}}
            // MERGE con lo que ya tengamos en el state para no borrar lo que el docente está escribiendo
            setNotas(prev => {
                const newNotas = { ...prev };
                (data.notas || []).forEach(n => {
                    newNotas[String(n.id_estudiante)] = {
                        proceso: (n.proceso !== null && n.proceso !== undefined) ? parseFloat(n.proceso) : '',
                        evaluacion: (n.evaluacion !== null && n.evaluacion !== undefined) ? parseFloat(n.evaluacion) : '',
                        nota: (n.nota_prueba !== null && n.nota_prueba !== undefined) ? parseFloat(n.nota_prueba) : ''
                    };
                });
                return newNotas;
            });
        } catch (error) {
            console.error('Error loading notas:', error);
        }
    };

    // const handleNotaChange = (id_estudiante, campo, valor) => {
    //     // Validar que sea número entre 0 y 50
    //     const numVal = parseFloat(valor);
    //     if (valor !== '' && (isNaN(numVal) || numVal < 0 || numVal > 50)) return;

    //     setNotas(prev => {
    //         const updated = {
    //             ...prev,
    //             [String(id_estudiante)]: {
    //                 ...(prev[String(id_estudiante)] || {}),
    //                 [campo]: valor
    //             }
    //         };

    //         // Calcular promedio automáticamente si es tipo 'curso'
    //         if (filters.tipo_preadmision === 'curso' && (campo === 'proceso' || campo === 'evaluacion')) {
    //             const proceso = parseFloat(campo === 'proceso' ? valor : (prev[String(id_estudiante)]?.proceso || 0));
    //             const evaluacion = parseFloat(campo === 'evaluacion' ? valor : (prev[String(id_estudiante)]?.evaluacion || 0));
    //             if (!isNaN(proceso) && !isNaN(evaluacion)) {
    //                 updated[String(id_estudiante)].promedio = ((proceso + evaluacion)).toFixed(1);
    //             }
    //         }

    //         return updated;
    //     });
    // };
    const handleNotaChange = (id_estudiante, campo, valor) => {
        // 1. Determinar el límite máximo según el tipo de preadmisión
        const maxNota = filters.tipo_preadmision === 'prueba' ? 100 : 50;

        // 2. Validar que sea número entre 0 y el máximo correspondiente (50 o 100)
        const numVal = parseFloat(valor);
        if (valor !== '' && (isNaN(numVal) || numVal < 0 || numVal > maxNota)) return;

        setNotas(prev => {
            const updated = {
                ...prev,
                [String(id_estudiante)]: {
                    ...(prev[String(id_estudiante)] || {}),
                    [campo]: valor
                }
            };

            // 3. Calcular promedio automáticamente si es tipo 'curso' (Proceso + Evaluación)
            if (filters.tipo_preadmision === 'curso' && (campo === 'proceso' || campo === 'evaluacion')) {
                const estudiantePrev = prev[String(id_estudiante)] || {};

                // Obtenemos el valor actual o el que ya estaba guardado en el estado anterior
                const proceso = parseFloat(campo === 'proceso' ? valor : (estudiantePrev.proceso || 0));
                const evaluacion = parseFloat(campo === 'evaluacion' ? valor : (estudiantePrev.evaluacion || 0));

                if (!isNaN(proceso) && !isNaN(evaluacion)) {
                    // Suma de notas sobre 50 + 50 da un total sobre 100
                    updated[String(id_estudiante)].promedio = (proceso + evaluacion).toFixed(1);
                }
            }

            return updated;
        });
    };  

    const handleGuardar = async () => {
        try {
            setSaving(true);
            const gestion = filters.gestion;

            const parseNota = (val) => {
                if (val === '' || val === null || val === undefined) return null;
                const parsed = parseFloat(val);
                return isNaN(parsed) ? null : parsed;
            };

            const promises = estudiantes.map(est => {
                const notaEst = notas[String(est.id_estudiante)] || {};
                const body = {
                    id_estudiante: est.id_estudiante,
                    id_asignatura: filters.id_asignatura,
                    id_paralelo: filters.id_paralelo || null,
                    tipo: filters.tipo_preadmision,
                    gestion,
                    ...(filters.tipo_preadmision === 'curso' ? {
                        proceso: parseNota(notaEst.proceso),
                        evaluacion: parseNota(notaEst.evaluacion)
                    } : {
                        nota_prueba: parseNota(notaEst.nota)
                    })
                };

                const token = localStorage.getItem('token');

                return fetch(`${API_URL}/docente/notas-preadmision`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify(body)
                }).then(res => {
                    if (!res.ok) throw new Error('Error en respuesta del servidor');
                    return res;
                });
            });

            await Promise.all(promises);
            alert('Notas guardadas exitosamente');
            await loadNotas();
        } catch (error) {
            console.error('Error saving notas:', error);
            alert('Error al guardar notas. Es posible que el servidor haya rechazado la petición.');
        } finally {
            setSaving(false);
        }
    };

    const handleDownload = () => {
        if (filteredEstudiantes.length === 0) {
            alert('No hay datos para exportar');
            return;
        }

        const dataToExport = filteredEstudiantes.map((est, idx) => {
            const notaEst = notas[String(est.id_estudiante)] || {};
            const base = {
                'No': idx + 1,
                'Codigo': est.codigo || est.codigo_estudiante || '-',
                'Nombres': est.nombres || '-',
                'Apellidos': est.apellidos || `${est.apellido_paterno || ''} ${est.apellido_materno || ''}`.trim() || '-'
            };

            if (filters.tipo_preadmision === 'curso') {
                return {
                    ...base,
                    'Proceso': notaEst.proceso || 0,
                    'Evaluación': notaEst.evaluacion || 0,
                    'Promedio': getPromedio(est.id_estudiante)
                };
            } else {
                return {
                    ...base,
                    'Nota': notaEst.nota || 0
                };
            }
        });

        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Notas Preadmisión');
        XLSX.writeFile(wb, `notas_preadmision_${filters.tipo_preadmision}_${filters.gestion}.xlsx`);
        setShowDownloadModal(false);
    };

    // Filtrar estudiantes por búsqueda
    const filteredEstudiantes = estudiantes.filter(est => {
        const searchLower = searchTerm.toLowerCase();
        return (
            (est.codigo || '').toLowerCase().includes(searchLower) ||
            (est.nombres || '').toLowerCase().includes(searchLower) ||
            (est.apellidos || est.apellido_paterno || '').toLowerCase().includes(searchLower)
        );
    });

    const getPromedio = (id_estudiante) => {
        const nota = notas[String(id_estudiante)] || {};
        const proceso = parseFloat(nota.proceso) || 0;
        const evaluacion = parseFloat(nota.evaluacion) || 0;
        if (proceso > 0 || evaluacion > 0) {
            return ((proceso + evaluacion)).toFixed(1);
        }
        return '-';
    };

    return (
        <div className="p-4 md:p-6 max-w-7xl mx-auto">
            {/* Mensaje si inscripciones cerradas */}
            {inscripcionCerrada ? (
                <div className="bg-white shadow-xl rounded-2xl p-8 mb-6 text-center border border-red-100 max-w-2xl mx-auto mt-10">
                    <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <svg className="w-10 h-10 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                    <h2 className="text-xl font-bold text-gray-800 mb-2">Periodo de Calificación Cerrado</h2>
                    <p className="text-gray-600 mb-4">{mensajeCierre}</p>
                </div>
            ) : (
                <>
                    {/* Header */}
                    <div className="mb-6">
                        <h1 className="text-xl font-bold text-gray-800">Docente &gt; Evaluaciones &gt; Admisión</h1>
                    </div>

                    {/* Filtros */}
                    <div className="flex flex-wrap gap-3 mb-6">

                        {/* Gestión */}
                        <div className="relative">
                            <select
                                value={filters.gestion}
                                onChange={(e) => setFilters({ ...filters, gestion: parseInt(e.target.value) })}
                                className="appearance-none pl-4 pr-10 py-2 border border-gray-300 rounded-full bg-white text-sm min-w-[100px]"
                            >
                                {[2024, 2025, 2026, 2027].map(g => (
                                    <option key={g} value={g}>{g}</option>
                                ))}
                            </select>
                            <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" size={18} />
                        </div>

                        {/* Tipo Preadmisión */}
                        <div className="relative">
                            <select
                                value={filters.tipo_preadmision}
                                onChange={(e) => setFilters({ ...filters, tipo_preadmision: e.target.value, id_asignatura: '', id_paralelo: '' })}
                                className="appearance-none pl-4 pr-10 py-2 border border-gray-300 rounded-full bg-white text-sm min-w-[180px]"
                            >
                                <option value="curso">Curso de Pre Admisión</option>
                                <option value="prueba">Prueba de Admisión Académica</option>
                            </select>
                            <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" size={18} />
                        </div>

                        {/* Asignatura */}
                        <div className="relative">
                            <select
                                value={filters.id_asignatura}
                                onChange={(e) => setFilters({ ...filters, id_asignatura: e.target.value, id_paralelo: '' })}
                                className="appearance-none pl-4 pr-10 py-2 border border-gray-300 rounded-full bg-white text-sm min-w-[150px]"
                            >
                                <option value="">Asignatura</option>
                                {asignaturas.map(a => (
                                    <option key={a.id_asignatura} value={a.id_asignatura}>{a.nombre}</option>
                                ))}
                            </select>
                            <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" size={18} />
                        </div>

                        {/* Paralelo */}
                        <div className="relative">
                            <select
                                value={filters.id_paralelo}
                                onChange={(e) => setFilters({ ...filters, id_paralelo: e.target.value })}
                                disabled={!filters.id_asignatura}
                                className="appearance-none pl-4 pr-10 py-2 border border-gray-300 rounded-full bg-white text-sm min-w-[120px] disabled:bg-gray-100"
                            >
                                <option value="">Paralelo</option>
                                {paralelos.map(p => (
                                    <option key={p.id_paralelo || p.paralelo} value={p.id_paralelo || p.paralelo}>{p.paralelo || p.nombre}</option>
                                ))}
                            </select>
                            <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" size={18} />
                        </div>

                        {/* Buscador */}
                        <div className="relative flex-1 max-w-xs">
                            <input
                                type="text"
                                placeholder="Buscar..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="w-full pl-4 pr-10 py-2 border border-gray-300 rounded-full text-sm"
                            />
                            <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
                        </div>

                        {/* Botón Descarga */}
                        <button
                            onClick={() => setShowDownloadModal(true)}
                            className="p-2 bg-blue-900 text-white rounded-full hover:bg-blue-800 transition-colors"
                            title="Descargar notas"
                        >
                            <Download size={20} />
                        </button>
                    </div>

                    {/* Tabla de notas */}
                    <div className="bg-white rounded-lg shadow overflow-hidden">
                        <div className="overflow-x-auto">
                            <table className="w-full text-sm">
                                <thead className="bg-gray-50 border-b">
                                    <tr>
                                        <th className="px-3 py-3 text-center font-semibold">No</th>
                                        <th className="px-3 py-3 text-center font-semibold">Codigo</th>
                                        <th className="px-3 py-3 text-center font-semibold">Nombres</th>
                                        <th className="px-3 py-3 text-center font-semibold">Apellidos</th>
                                        {filters.tipo_preadmision === 'curso' ? (
                                            <>
                                                <th className="px-3 py-3 text-center font-semibold">Procesos</th>
                                                <th className="px-3 py-3 text-center font-semibold">Evaluación</th>
                                                <th className="px-3 py-3 text-center font-semibold">Promedio</th>
                                            </>
                                        ) : (
                                            <th className="px-3 py-3 text-center font-semibold">Nota</th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody className="divide-y">
                                    {loading ? (
                                        <tr><td colSpan={filters.tipo_preadmision === 'curso' ? 7 : 5} className="px-4 py-8 text-center text-gray-500">Cargando...</td></tr>
                                    ) : filteredEstudiantes.length === 0 ? (
                                        <tr><td colSpan={filters.tipo_preadmision === 'curso' ? 7 : 5} className="px-4 py-8 text-center text-gray-500">
                                            {filters.id_asignatura ? 'No hay estudiantes para mostrar' : 'Seleccione una asignatura'}
                                        </td></tr>
                                    ) : (
                                        filteredEstudiantes.map((est, index) => (
                                            <tr key={est.id_estudiante} className="hover:bg-gray-50">
                                                <td className="px-3 py-3 text-center">{index + 1}</td>
                                                <td className="px-3 py-3 text-center">{est.codigo || est.codigo_estudiante || '-'}</td>
                                                <td className="px-3 py-3 text-center">{est.nombres || '-'}</td>
                                                <td className="px-3 py-3 text-center">{est.apellidos || `${est.apellido_paterno || ''} ${est.apellido_materno || ''}`.trim() || '-'}</td>
                                                {filters.tipo_preadmision === 'curso' ? (
                                                    <>
                                                        <td className="px-3 py-3 text-center">
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                max="100"
                                                                value={notas[String(est.id_estudiante)]?.proceso || ''}
                                                                onChange={(e) => handleNotaChange(est.id_estudiante, 'proceso', e.target.value)}
                                                                onBlur={(e) => {
                                                                    const valor = e.target.value;
                                                                    if (valor !== '') {
                                                                        handleNotaChange(est.id_estudiante, 'proceso', String(Math.round(Number(valor))));
                                                                    }
                                                                }}
                                                                className="w-16 px-2 py-1 border border-gray-300 rounded text-center text-sm"
                                                                placeholder=" - "
                                                            />
                                                        </td>
                                                        <td className="px-3 py-3 text-center">
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                max="100"
                                                                value={notas[String(est.id_estudiante)]?.evaluacion || ''}
                                                                onChange={(e) => handleNotaChange(est.id_estudiante, 'evaluacion', e.target.value)}
                                                                onBlur={(e) => {
                                                                    const valor = e.target.value;
                                                                    if (valor !== '') {
                                                                        handleNotaChange(est.id_estudiante, 'evaluacion', String(Math.round(Number(valor))));
                                                                    }
                                                                }}
                                                                className="w-16 px-2 py-1 border border-gray-300 rounded text-center text-sm"
                                                                placeholder=" - "
                                                            />
                                                        </td>
                                                        <td className="px-3 py-3 text-center font-medium">{getPromedio(est.id_estudiante)}</td>
                                                    </>
                                                ) : (
                                                    <td className="px-3 py-3 text-center">
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            max="100"
                                                            value={notas[String(est.id_estudiante)]?.nota || ''}
                                                            onChange={(e) => handleNotaChange(est.id_estudiante, 'nota', e.target.value)}
                                                            onBlur={(e) => {
                                                                const valor = e.target.value;
                                                                if (valor !== '') {
                                                                    handleNotaChange(est.id_estudiante, 'nota', String(Math.round(Number(valor))));
                                                                }
                                                            }}
                                                            className="w-16 px-2 py-1 border border-gray-300 rounded text-center text-sm"
                                                            placeholder=" - "
                                                        />
                                                    </td>
                                                )}
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Botón Guardar */}
                        {filteredEstudiantes.length > 0 && (
                            <div className="p-4 border-t flex justify-end">
                                <button
                                    onClick={handleGuardar}
                                    disabled={saving}
                                    className="px-6 py-2 bg-blue-900 text-white rounded-md hover:bg-blue-800 disabled:opacity-50"
                                >
                                    {saving ? 'Guardando...' : 'Guardar Notas'}
                                </button>
                            </div>
                        )}
                    </div>

                    {/* Modal Descarga */}
                    {showDownloadModal && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                            <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
                                <div className="flex justify-between items-center px-6 py-4 border-b">
                                    <h2 className="text-xl font-bold text-blue-900">Descargar Notas (Preadmisión)</h2>
                                    <button onClick={() => setShowDownloadModal(false)} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
                                </div>
                                <div className="p-6 space-y-4 text-center">
                                    <div className="bg-blue-50 p-4 rounded-xl mb-4">
                                        <p className="text-sm text-blue-800 font-bold mb-1">
                                            Confirmar Descarga de Reporte
                                        </p>
                                        <p className="text-xs text-blue-600">
                                            Se exportará la lista actual con {filteredEstudiantes.length} estudiantes.
                                        </p>
                                    </div>
                                    <p className="text-sm text-gray-600">
                                        ¿Desea generar el archivo Excel con las calificaciones de <strong>{filters.tipo_preadmision === 'curso' ? 'CPA' : 'PAA'} - {filters.gestion}</strong>?
                                    </p>
                                </div>
                                <div className="flex justify-end px-6 py-4 border-t">
                                    <button onClick={() => setShowDownloadModal(false)} className="px-6 py-2 border border-gray-300 rounded-md hover:bg-gray-50 text-sm font-bold">Cancelar</button>
                                    <button onClick={handleDownload} className="px-8 py-2 bg-blue-900 text-white rounded-md hover:bg-blue-800 text-sm font-bold shadow-lg shadow-blue-900/20">Descargar Excel</button>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
